import { useParams } from 'quartz-routing/react-router';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withPathParams(WrappedComponent) {
  const WrapperComponentWithParams = props => {
    const params = useParams();
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      params: params
    }));
  };
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WrapperComponentWithParams.displayName = `ComponentWithPathParams(${displayName})`;
  return WrapperComponentWithParams;
}